export default "__VITE_ASSET__tBBugUiH__"